(() => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__bcgiftProductCreditHintLoaded) return;
  window.__bcgiftProductCreditHintLoaded = true;

  async function readJson(response) {
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload?.ok === false) {
      throw new Error(payload?.error || `Request failed: ${response.status}`);
    }
    return payload;
  }

  function resolveLocale() {
    const shopifyLocale = window.Shopify?.locale || window.Shopify?.country || '';
    const documentLocale = document.documentElement?.lang || '';
    const pathLocale = window.location.pathname || '';
    const searchLocale = new URLSearchParams(window.location.search || '').get('locale') || '';
    const combined = `${searchLocale} ${shopifyLocale} ${documentLocale} ${pathLocale}`;
    return /(?:^|[\s/_-])zh(?:[\s/_-]|$)/i.test(combined) || /^zh/i.test(combined) ? 'zh-CN' : 'en';
  }

  function renderHint(hint) {
    const state = hint?.state || 'neutral';
    const labels = hint?.labels || {};
    const locale = hint?.locale || resolveLocale();
    const tier = hint?.memberTierName || (locale === 'zh-CN' ? '会员' : 'Member');
    const balance = Number(hint?.creditBalance || 0);
    const badges = Array.isArray(hint?.badges) ? hint.badges.filter(Boolean) : [];
    const meta = [];

    if (tier) meta.push(`${labels.tier || (locale === 'zh-CN' ? '等级' : 'Tier')}: ${tier}`);
    if (state === 'eligible') meta.push(`${labels.availableCredit || (locale === 'zh-CN' ? '可用积分' : 'Available credit')}: ${balance.toFixed(2)}`);
    badges.forEach((badge) => meta.push(badge));

    return `
      <p class="bcgift-product-credit-hint__eyebrow">${labels.eyebrow || (locale === 'zh-CN' ? 'BCgift 会员提示' : 'BCgift member hint')}</p>
      <p class="bcgift-product-credit-hint__headline">${hint?.headline || labels.defaultHeadline || (locale === 'zh-CN' ? '会员等级与积分提示' : 'Member tier and credit guidance')}</p>
      <p class="bcgift-product-credit-hint__message">${hint?.message || ''}</p>
      ${meta.length ? `<ul class="bcgift-product-credit-hint__meta">${meta.map((item) => `<li>${item}</li>`).join('')}</ul>` : ''}
    `;
  }


  function normalizeProductPurchaseFlow(root) {
    const detailsStack = root?.closest('.product-information__details-stack') || document.querySelector('.product-information__details-stack');
    const productDetails = detailsStack?.querySelector('.product-details');
    const flow = productDetails?.querySelector('.group-block-content');
    if (!flow) return;

    const children = Array.from(flow.children);
    const buyButtons = flow.querySelector('.buy-buttons-block');
    const accordion = flow.querySelector('.accordion');
    if (!buyButtons) return;

    const productDescription = children.find((el) => {
      const cls = String(el.className || '');
      return cls.includes('product_description') || cls.includes('product-description');
    });

    const productDetailsBlock = children.find((el) => {
      if (el === productDescription || el === buyButtons || el === accordion || el === root) return false;
      const text = (el.innerText || el.textContent || '').replace(/\s+/g, ' ').trim();
      return /^Product Details\b/i.test(text) || text.includes('Product Details Material:');
    });

    // Keep Note and Product Details above the cart/buy area.
    [productDetailsBlock, productDescription].filter(Boolean).reverse().forEach((el) => {
      if (el.compareDocumentPosition(buyButtons) & Node.DOCUMENT_POSITION_FOLLOWING) return;
      flow.insertBefore(el, buyButtons);
    });

    // Keep member hint inside the same purchase flow, directly before buy buttons.
    // Desired whisky mobile order: variant picker -> member hint -> buy buttons/testing notice -> accordion.
    if (root && buyButtons?.parentNode === flow && root.previousElementSibling !== buyButtons) {
      flow.insertBefore(root, buyButtons);
    }
  }


  function mountRoot(root) {
    if (!root) return;
    normalizeProductPurchaseFlow(root);
    root.dataset.bcgiftProductCreditHintMounted = 'true';
  }

  async function initRoot(root) {
    mountRoot(root);
    const loadingNode = root.querySelector('[data-product-credit-hint-loading]');
    const contentNode = root.querySelector('[data-product-credit-hint-content]');
    const endpoint = root.dataset.endpoint;
    const productHandle = root.dataset.productHandle || '';
    const customerGid = root.dataset.customerGid || '';
    if (!endpoint || !productHandle) {
      root.hidden = true;
      return;
    }

    try {
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('product_handle', productHandle);
      if (customerGid) url.searchParams.set('customer_gid', customerGid);
      url.searchParams.set('locale', resolveLocale());
      const payload = await readJson(await fetch(url.toString(), { headers: { Accept: 'application/json' }, cache: 'no-store' }));
      if (!payload?.hint) {
        root.hidden = true;
        return;
      }
      contentNode.innerHTML = renderHint(payload.hint);
      contentNode.hidden = false;
      if (loadingNode) loadingNode.hidden = true;
    } catch (_error) {
      root.hidden = true;
    }
  }

  function scan() {
    document.querySelectorAll('[data-bcgift-product-credit-hint-root]').forEach((root) => {
      mountRoot(root);
      if (root.dataset.bcgiftProductCreditHintBound === 'true') return;
      root.dataset.bcgiftProductCreditHintBound = 'true';
      initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }
  window.setTimeout(scan, 250);
  window.setTimeout(scan, 750);
})();
